const DEFAULT_MAX_TOTAL_LINES = 8;
const EXPANDED_MAX_TOTAL_LINES = 14;

function getNumericLineHeight(element) {
    const computedStyle = window.getComputedStyle(element);
    const lineHeight = Number.parseFloat(computedStyle.lineHeight);

    if (Number.isFinite(lineHeight)) {
        return lineHeight;
    }

    const fontSize = Number.parseFloat(computedStyle.fontSize);
    return Number.isFinite(fontSize) ? fontSize * 1.2 : 0;
}

function clampArticleCard(card) {
    const titleElement = card.querySelector('.card-title');
    const titleLink = card.querySelector('.card-title a');
    const textElement = card.querySelector('.card-text');

    if (!titleElement || !titleLink || !textElement) {
        return;
    }

    if (!textElement.dataset.fullText) {
        const normalizedText = textElement.textContent.trim().replace(/\s+/g, ' ');
        textElement.dataset.fullText = normalizedText;
        textElement.setAttribute('data-full-text', normalizedText);
    }

    const fullText = textElement.dataset.fullText;
    const configuredMaxTotalLines = Number.parseInt(card.dataset.maxTotalLines, 10);
    const maxTotalLines = Number.isFinite(configuredMaxTotalLines) && configuredMaxTotalLines > 0
        ? configuredMaxTotalLines
        : card.classList.contains('expanded')
            ? EXPANDED_MAX_TOTAL_LINES
            : DEFAULT_MAX_TOTAL_LINES;

    textElement.classList.add('is-measured');
    card.classList.add('card--measured');
    textElement.textContent = fullText;

    if (!fullText) {
        textElement.style.maxHeight = '0px';
        return;
    }

    const textLineHeight = getNumericLineHeight(textElement);

    if (!textLineHeight) {
        return;
    }

    const titleStyles = window.getComputedStyle(titleElement);
    const titleMarginBottom = Number.parseFloat(titleStyles.marginBottom) || 0;
    const titleHeight = titleLink.getBoundingClientRect().height + titleMarginBottom;
    const maxContentHeight = Math.floor(maxTotalLines * textLineHeight);
    const maxHeight = Math.max(0, Math.floor(maxContentHeight - titleHeight));

    textElement.style.maxHeight = `${maxHeight}px`;

    if (maxHeight === 0) {
        textElement.textContent = '';
        return;
    }

    if (textElement.scrollHeight <= maxHeight) {
        return;
    }

    const words = fullText.split(/\s+/);
    let low = 0;
    let high = words.length;
    let bestFit = '...';

    while (low <= high) {
        const middle = Math.floor((low + high) / 2);
        const candidateText = words.slice(0, middle).join(' ').trim();
        const candidate = candidateText ? `${candidateText}...` : '...';

        textElement.textContent = candidate;

        if (textElement.scrollHeight <= maxHeight) {
            bestFit = candidate;
            low = middle + 1;
        } else {
            high = middle - 1;
        }
    }

    textElement.textContent = bestFit;
}

function clampArticleCards() {
    document.querySelectorAll('.card-clamp').forEach(clampArticleCard);
}

let resizeFrame = null;

function scheduleClampArticleCards() {
    if (resizeFrame !== null) {
        window.cancelAnimationFrame(resizeFrame);
    }

    resizeFrame = window.requestAnimationFrame(() => {
        clampArticleCards();
        resizeFrame = null;
    });
}

document.addEventListener('DOMContentLoaded', scheduleClampArticleCards);
window.addEventListener('load', scheduleClampArticleCards);
window.addEventListener('resize', scheduleClampArticleCards);

if (document.fonts?.ready) {
    document.fonts.ready.then(scheduleClampArticleCards);
}

window.clampArticleCards = clampArticleCards;
